/**
 * @param {number} value
 * @returns {string}
 */
export function R$(value) {
  if (typeof value === "undefined") {
    return undefined;
  }

  return value.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}



// WEBPACK FOOTER //
// ./src/rifa/utils/brl.js